import { render, staticRenderFns } from "./TeacherRegister.vue?vue&type=template&id=b37cc104"
import script from "./TeacherRegister.vue?vue&type=script&lang=js"
export * from "./TeacherRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports